import fileDownload from 'js-file-download'
import fetch from "./fetch";
import msg from "./msg";
import {Loading, Message} from 'element-ui';
import system from './system'
export default {
    down(url, params, method,dataOrparams) {
        const loading = msg.loading("组织数据中...");
        var config = {responseType: 'arraybuffer', method: method || 'post'}
        if(dataOrparams == 'data'){
            config = {...config, data: params}
        }else{
            config = {...config, params: params}
        }
        fetch(url, config).then(res => {
            loading.close();
            if (res.status !== 200) {
                if(res.message!=null){
                    Message({
                        // message: res.message,
                        message: "res.message",
                        type: 'error',
                        duration: 5 * 1000
                    });
                }
            } else {
                let disposition = res.headers['content-disposition']
                let filename = decodeURI(disposition.match(/filename=(.*)/)[1])
                fileDownload(res.data, filename)
            }
        }).catch(err=>{
            loading.close();
            return Promise.reject(err);
        })
    },
    upload(file, refobj) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("refid", refobj.refid);
        formData.append("reftype", refobj.reftype);
        formData.append("flag", refobj.flag);
        return fetch.post("/api/file/fileopt/upload", formData, {headers: {'Content-Type': 'multipart/form-data'}})
    },
    uploadToShowManyPlace(file, refobj) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("refid", refobj.refid);
        formData.append("reftype", refobj.reftype);
        formData.append("flag", refobj.flag);
        return fetch.post("/api/file/fileopt/uploadToShowManyPlace", formData, {headers: {'Content-Type': 'multipart/form-data'}})
    },
    importExcel(file, refobj) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("clsname", refobj.clsname);
        formData.append("startrow", refobj.startrow);
        formData.append("extparams", JSON.stringify(refobj.extparams));
        return fetch.post("/api/file/fileopt/importExcel", formData, {headers: {'Content-Type': 'multipart/form-data'}})
    },
    importBatchExcel(file, refobj) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("clsname", refobj.clsname);
        formData.append("startrow", refobj.startrow);
        formData.append("extparams", JSON.stringify(refobj.extparams));
        return fetch.post("/api/file/fileopt/importFlTargetExcel", formData, {headers: {'Content-Type': 'multipart/form-data'}})
    },
    uploadExcel(url,file) {
        const formData = new FormData();
        formData.append("file", file);
        // formData.append("refid", refobj);
        return fetch.post(url, formData, {headers: {'Content-Type': 'multipart/form-data'}})
    },
    downByid(id){
        this.down("/api/file/fileopt/down",{id},'get')
    },
    downByrefidtype(refobj){
        this.down("/api/file/fileopt/refdown",refobj,'post')
    },
    deleteById(id){
        return fetch({
            url: "/api/file/fileopt/deleteById",
            method: 'post',
            params: {id}
        })
    },
    listdownfile(params){
        return fetch({
            url: "/api/file/fileopt/list",
            method: 'post',
            params: params
        })
    },
    uploadTX(file, refobj) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("refid", refobj.refid);
        formData.append("reftype", refobj.reftype);
        formData.append("flag", refobj.flag);
        return fetch.post("/api/file/fileopt/uploadTX", formData, {headers: {'Content-Type': 'multipart/form-data'}})
    },
    listTX(params){
        return fetch({
            url: "/api/file/fileopt/listTX",
            method: 'post',
            params: params
        })
    },
    // 下载 图片方法
    png (data, fileName) {
        this.download(data, fileName, 'application/png')
    },

    download (data, fileName, mineType) {
        // 创建 blob对象
        let blob = new Blob([data], { type: mineType })
        // 浏览器api 有的不支持-二种都写
        window.URL = window.URL || window.webkitURL
        // 获取链接地址-(内容赋值到临时链接)
        let href = URL.createObjectURL(blob)
        // 创建a标签
        let downA = document.createElement('a')
        // 把链接赋值给a标签
        downA.href = href
        // 赋值文件名称
        downA.download = fileName
        // 点击下载
        downA.click()
        // 销毁超连接
        window.URL.revokeObjectURL(href)
    },

}

